export default function getWarehouseRules(configuration) {
  const { width, xWallSegmentWidth } = configuration;

  return {
    length: {
      default: 15,
      min: width,
      max: 200,
      step: xWallSegmentWidth,
    },
    width: {
      default: 15,
      min: 10,
      max: 40,
      step: 5,
    },
    height: {
      default: 5.2,
      min: 4.2,
      max: 6.2,
      values: [4.2, 5.2, 6.2],
    },
  };
}
